module.exports = __webpack_public_path__ + "img/mojedelo.9c80035e.svg";